import React, { FC, PropsWithChildren } from "react";

export const SurveyViewWrapper: FC<PropsWithChildren> = ({ children }) => {
  // 232px is height of all elements besides table content
  return <div className="flex justify-center">{children}</div>;
};
